import React from 'react';
import { Currency, DateTime } from '~/components';
import { BulkActionModal } from '~/components/bulk-action';
import { useApi, useWorkspace } from '~/contexts';
import { revenueTypes } from './revenueTypes';

export default function BulkDelete({ projectId, ids, currency, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  const renderRow = ({ revenueAdjustment }) => (
    <>
      <DateTime value={revenueAdjustment.date} /> &middot; {revenueTypes[revenueAdjustment.revenueType]} &middot;{' '}
      <Currency value={revenueAdjustment.amount} currency={currency} />
    </>
  );

  return (
    <BulkActionModal
      title="Delete Earned Revenue Adjustments"
      variant="delete"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .projectSettings(projectId)
          .revenueAdjustments()
          .bulkDelete(ids)
          .then((r) => r.data)
      }
      renderRow={renderRow}>
      {`This will delete ${
        ids.length === 1
          ? 'the selected earned revenue adjustment'
          : `the ${ids.length} selected earned revenue adjustments`
      }. This action cannot be undone.`}
    </BulkActionModal>
  );
}
